export const coachingKeys = {
  all: ['coaching'] as const,
  conversations: () => [...coachingKeys.all, 'conversations'] as const,
  conversationLists: () => [...coachingKeys.conversations(), 'list'] as const,
  conversationList: (userId: string | null) => [...coachingKeys.conversationLists(), userId] as const,
  conversationDetails: () => [...coachingKeys.conversations(), 'detail'] as const,
  conversationDetail: (conversationId: string | null, viewerKey?: string) =>
    [...coachingKeys.conversationDetails(), conversationId, ...(viewerKey ? [viewerKey] : [])] as const,
  conversationMessages: (conversationId: string | null, viewerKey?: string) =>
    [...coachingKeys.conversations(), 'messages', conversationId, ...(viewerKey ? [viewerKey] : [])] as const,
}
